<template>
  <b-dropdown
    text="Filter"
    variant="outline-primary"
    toggle-class="d-flex justify-content-between align-items-center rounded-sm"
    style="width: 160px"
    class="mr-2"
  >
    <div style="width: 300px" class="px-3 text-md filter-group">
      <input
        @input="handleSearch"
        type="text"
        class="form-control mb-2 text-sm"
        placeholder="Search..."
        v-model="search"
        style="width: 100%"
      />
      <div v-for="(item, index) in filters" :key="index" class="mb-1">
        <div class="d-flex align-items-center">
          <i
            :class="{
              'rotate-90': item.collapse,
              'rotate-0': !item.collapse,
            }"
            class="fa fa-caret-right mr-2 cursor-pointer"
            @click="item.collapse = !item.collapse"
          ></i>
          <input
            type="checkbox"
            style="width: 14px; height: 14px"
            class="mr-2 cursor-pointer"
            :checked="
              item.selected.length == item.options.length && item.options.length
            "
            @input="(e) => handleCheckedAll(item, e)"
          />
          <strong
            class="mb-0 text-sm cursor-pointer"
            @click="item.collapse = !item.collapse"
            >{{ item.label }}
            {{
              item.selected?.length ? `(${item.selected?.length})` : ''
            }}</strong
          >
        </div>
        <b-collapse v-model="item.collapse">
          <div
            class="d-flex align-items-center ml-4"
            v-for="(option, idx) in item.options"
            :key="idx"
          >
            <template
              v-if="option?.text?.toLowerCase().includes(search?.toLowerCase())"
            >
              <input
                type="checkbox"
                style="width: 14px; height: 14px"
                class="mr-2 cursor-pointer"
                :value="option?.value"
                v-model="item.selected"
                :id="'option-check-' + option?.value"
              />
              <label
                :for="'option-check-' + option?.value"
                class="mb-0 text-sm cursor-pointer"
                >{{ option?.text }}</label
              >
            </template>
          </div>
        </b-collapse>
      </div>
    </div>
  </b-dropdown>
</template>
<script>
export default {
  name: 'FilterGroup',
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      // EXAPMPLE DATA FILTERS
      //   filters: [
      //     {
      //       name: '',
      //       field:'fleets',
      //       options: [
      //         { text: 'tb mt-101', value: '1' },
      //         { text: 'tb mt-102', value: '2' },
      //         { text: 'tb mt-104', value: '4' },
      //       ],
      //       selected: [],
      //       collapse: false,
      //       checkedAll: false,
      //     },
      //   ],
    }
  },
  methods: {
    handleCheckedAll(item, event) {
      const { checked } = event.target
      if (checked) {
        item.selected = item.options.map((el, i) => el.value)
      } else {
        item.selected = []
      }
    },
    handleSearch() {
      this.filters.forEach((item) => {
        if (this.search) {
          item.collapse = true
        } else {
          item.collapse = false
        }
      })
    },
  },
}
</script>
<style scoped>
.text-sm {
  font-size: 12px !important;
}

.text-md {
  font-size: 16px !important;
}

.rotate-90 {
  rotate: 90deg;
}

.rotate-0 {
  rotate: 0deg;
}

.filter-group {
  max-height: 320px;
  overflow: auto;
}
</style>
